import * as G from "@globals";
import { produce, } from "immer";
import type { Store, } from "../useStore";
import type { WalletSliceSetter, } from "./types";


export const WalletSliceDefaultprops = {
	address: null,
	anonymous: true,
	balance: {
		usd: -1,
		brkt: "0",
	},
	brkt_balance: BigInt(0),
	brkt_conv_rate: 0,
	chain: null,
	chainId: null,
	checked_in: false,
	client: {
		readable: null,
		writable: null,
	},
	controller: new AbortController(),
	eth_balance: BigInt(0),
	eth_price: 0,
	fetching: false,
	isConnected: false,
	isDisconnected: true,
	isSupportedChain: false,
	modal_active: false,
	poll_listener: null,
	ready: false,
	trm_pass: true,
	whitelisted: false,
	user: null,
	country_code: null,
	kyc_level: 0,
	kyc_active: false,
	_modalSub: null,
	resetting: false,
	claim_amount: BigInt(0),
	has_claim: false,
	claiming: false,
	claim_proof: [],
};


export const resetToDefaults = ( set: WalletSliceSetter ) => {
	Object.entries(WalletSliceDefaultprops).forEach(([key, value]) => {
		set(produce<Store>(state => {
			if(key in state.wallet) {
				state.wallet[key] = value;
			} else {
				console.warn("store:wallet::resetToDefaults:: key", key, "not in state.wallet, yet we are setting it");
			}
		}));
	});
	G.wallet.setBracketWalletAnonymous();
}
